import React, { useState, useCallback, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { 
    ChevronLeft, Menu, Home, LayoutDashboard, Users, 
    BarChart3, Layers, Wallet, Ticket, Globe, Settings2, 
    FileText, FileCode, InfoIcon 
} from "lucide-react";

const AdminSidebar = () => {
    const [isOpen, setIsOpen] = useState(() => 
        JSON.parse(localStorage.getItem("sidebarOpen")) || false
    );
    const location = useLocation();

    const toggleSidebar = useCallback(() => {
        setIsOpen(prev => {
            const newState = !prev;
            localStorage.setItem("sidebarOpen", JSON.stringify(newState));
            return newState;
        });
    }, []);

    const isActive = (path) => location.pathname === path;

    useEffect(() => {
        document.body.style.overflow = isOpen ? "hidden" : "auto";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isOpen]);

    const menuItems = [
        { path: "/home", label: "Home", icon: Home },
        { path: "/overview", label: "Dashboard", icon: LayoutDashboard },
        { path: "/publishers", label: "Publishers", icon: Users },
        { path: "/webanalytics", label: "Web Analytics", icon: BarChart3 },
        { path: "/appanalytics", label: "App Analytics", icon: BarChart3 },
        { path: "/adunits", label: "Adunits", icon: Layers },
        { path: "/transactions", label: "Transactions", icon: Wallet },
        // { path: "/qa-tickets", label: "QA Tickets", icon: Ticket },
        { path: "/invoice", label: "Invoice", icon: FileText },
        { path: "/website", label: "Website/Apps", icon: Globe },
        { path: "/webreports", label: "Reports-Web", icon: FileCode },
        { path: "/appreports", label: "Reports-App", icon: FileCode },
        { path: "/admin/payment-info", label: "Payment information", icon: InfoIcon },
        // { path: "/AdsTxtConfiguration", label: "AdsTxt Configuration", icon: Settings2 },
        // { path: "/AdsCodeConfiguration", label: "AdsCode Configuration", icon: FileCode },
        // { path: "/notes", label: "Notes", icon: InfoIcon },
    ];

    return (
        <div className="relative">
            {/* Overlay for Mobile */}
            {isOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
                    onClick={toggleSidebar}
                ></div>
            )}

            {/* Sidebar */}
            <aside 
                className={`fixed top-0 left-0 h-full w-64 bg-[#1E293B] text-gray-100 
                    transition-transform duration-300 z-50 ${isOpen ? "translate-x-0" : "-translate-x-64"} 
                    md:relative md:translate-x-0 md:w-64 shadow-lg`}
                aria-label="Sidebar"
            >
                {/* Close Button for Mobile */}
                <button 
                    className="absolute top-4 right-4 text-gray-400 md:hidden hover:text-blue-400" 
                    onClick={toggleSidebar}
                    aria-label="Close Sidebar"
                >
                    <ChevronLeft size={24} />
                </button>

                {/* Logo */}
                <div className="flex justify-center items-center bg-[#334155] p-4">
                    <img src="/Images/logo.png" className="h-16 mx-auto" alt="Logo" />
                </div>

                {/* Menu Items */}
                <ul className="space-y-2 pt-6">
                    {menuItems.map(({ path, label, icon: Icon }) => (
                        <li key={path}>
                            <Link to={path} className="block">
                                <div
                                    className={`flex items-center gap-3 rounded-lg p-3 mx-2 cursor-pointer 
                                        transition-all duration-200 ${
                                            isActive(path) 
                                                ? "bg-blue-600 text-white shadow-md shadow-blue-300"
                                                : "text-gray-300 hover:bg-blue-500 hover:text-white"
                                        }`}
                                >
                                    <Icon size={20} />
                                    <span>{label}</span>
                                </div>
                            </Link>
                        </li>
                    ))}
                </ul>
            </aside>

            {/* Mobile Toggle Button */}
            <button
                className="md:hidden p-3 text-gray-100 fixed top-4 left-4 z-50 bg-[#1E293B] rounded-full shadow-lg"
                onClick={toggleSidebar}
                aria-label="Open Sidebar"
                aria-expanded={isOpen}
            >
                <Menu size={28} />
            </button>
        </div>
    );
};

export default AdminSidebar;
